import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { MeasureService } from '../../measure/measure.service';
import { ResearchService } from '../research.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-research-measure',
  templateUrl: './research-measure.component.html',
  styleUrls: ['./research-measure.component.scss']
})
export class ResearchMeasureComponent implements OnInit {

  link: string;
  measure
  measureForm: FormGroup;
  // progressVal: number;
  countProgress: number = 0;
  measureButtonStatus: boolean = false;
  type: string = 'research';
  isLoading: boolean = false;
  researchID: string;
  waveID: string;
  researchDetail: any;

  constructor(
    private fb: FormBuilder,
    private measureService: MeasureService,
    private router: Router,
    public matDialog: MatDialog,
    private route: ActivatedRoute,
    private location: Location,
    private researchService: ResearchService,
    private gobalFunctionService: GobalFunctionService
  ) { }


  ngOnInit(): void {
    this.waveID = new URL(location.href).searchParams.get('wave_id');
    this.researchID = new URL(location.href).searchParams.get('research_id');

    this.isLoading = true;
    if (this.measureService.accessLink) {
      this.measureService.DetailMeasureResearchStart().pipe(
        switchMap(res => {
          if (res.success) {
            this.isLoading = false;
            this.measure = res.result[0];
            // // console.log(this.measure);
            this.gobalFunctionService.setTitle(this.measure.MEASURE_NAME);

            return this.researchService.getlDetailResearchByMeasure(this.researchID).pipe(
              map(research => {
                this.researchDetail = research.result[0];
              })
            )

          } else if (res.result[0].IS_VIEW === 1) {
            this.isLoading = false;
            alert('ไม่สามารถเข้าถึงแบบทดสอบนี้ได้');
            this.router.navigate(['/']);
            return of(null);
          }
        }),
        catchError((err) => {
          this.isLoading = false;
          alert(err.error.message);
          this.router.navigate(['/']);
          return of(null);
        })
      ).subscribe();
    } else {
      this.location.back();
    }



    this.measureForm = this.fb.group({
      DATA: this.fb.array([]),
    });

    // this.progress();

  }

  mStatus() {
    // // console.log(this.measureForm);
    if (this.measureForm.value.DATA.length === this.measure.details.length) {
      this.measureButtonStatus = true;
    }
  }

  send(form) {
    let body = {
      WAVE_ID: this.waveID,
      MEASURE_ID: this.measure.MEASURE_ID,
      RESEARCH_ID: this.researchID,
      PK_OF_MEASURE: `PM${Math.round(new Date().getTime() / 1000)}`,
      DATA: []
    }

    form.value.DATA.forEach(e => {
      body.DATA.push({
        ID: e.ID,
        ANSWER: JSON.stringify(e.ANSWER)
      })
    });

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'ส่งแบบทดสอบ',
      description: `<p>คุณต้องการส่งแบบทดสอบใช่หรือไม่?</p>`,
      cancleBtnText: 'ย้อนกลับ',
      actionBtnText: 'ตกลง',
    }

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    this.isLoading = true;
    modal.afterClosed().pipe(

      switchMap(res => {
        if (res) {
          return this.researchService.sendAnswerOfResearch(body).pipe(
            switchMap(res => {
              const dialogConfig1 = new MatDialogConfig();
              if (res) {
                // // console.log(res);
                this.isLoading = false;
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '350px';
                dialogConfig1.autoFocus = false;

                if (this.measure.COIN > 0 && res.result.status_done) {
                  dialogConfig1.data = {
                    cancleBtnText: 'ยืนยัน',
                    title: `ส่งแบบทดสอบ`,
                    description: `<img src="../../../assets/coin.png" width="80px;" class="img-center">คุณได้รับได้ ${this.researchDetail.COIN} Coin`
                  }
                } else {
                  dialogConfig1.data = {
                    title: 'ส่งแบบทดสอบ',
                    description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                                <p class="title text-center">ส่งแบบทดสอบสำเร็จ</p>`,
                    cancleBtnText: 'ยืนยัน',
                    customStyle: 'background-color: #58595B'
                  }
                }
              }

              const modal = this.matDialog.open(ModalComponent, dialogConfig1);
              return modal.afterClosed().pipe(
                map(r => {
                  if (!r) {
                    location.reload();
                  }
                })
              )
            })
          )
        } else {
          this.isLoading = false;
          return of(null)
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(null);
      }),
    ).subscribe();


  }

}
